import { render, staticRenderFns } from "./GenAiEmployeesModal.vue?vue&type=template&id=15967af2&scoped=true&"
import script from "./GenAiEmployeesModal.vue?vue&type=script&lang=ts&"
export * from "./GenAiEmployeesModal.vue?vue&type=script&lang=ts&"
import style0 from "./GenAiEmployeesModal.vue?vue&type=style&index=0&id=15967af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15967af2",
  null
  
)

export default component.exports